import script from "./DeleteUserPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteUserPage.vue?vue&type=script&setup=true&lang=js"

import "./DeleteUserPage.vue?vue&type=style&index=0&id=2e3127c3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e3127c3"]])

export default __exports__